import React from 'react'
import PageShell from '../shared/components/PageShell'
import { Box, Button, Typography, Grid } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import imageProtocols from '../assets/Protocols.svg';
import imageData from '../assets/Data.svg';
import imageAlgorithms from '../assets/Algorithms.svg';
import { useNavigate } from 'react-router-dom';


export default function Download({ image }) {

    return (
        <Box sx={{ width: '100%' }}>
            <PageShell>
                <Box sx={{ width: '100%' }}>
                    <Typography variant='h4'>
                        Download
                    </Typography>
                </Box>
            </PageShell>
            <PageShell pb={'100px'}>
                <Grid
                    container
                    sx={{
                        width: '100%',
                        justifyContent: 'space-evenly'
                    }}
                    spacing={{ xs: 4, md: 2 }}
                >
                    <Grid size={{ xs: 12, sm: 10, md: 4, lg: 3 }} >
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}>
                            <TarjetaDescargas
                                title={'Protocols'}
                                desc={'Download all experimental protocols generated by the project'}
                                image={imageProtocols}
                                page={'https://drive.google.com/drive/folders/1uJpEd6a_QcPb_eAEvqMSm54KmxiXZWhg?usp=sharing'}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 10, md: 4, lg: 3 }}>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}>
                            <TarjetaDescargas
                                title={'Algorithms'}
                                desc={'Download bioinformatic algorithms for the identification of resistance genes'}
                                image={imageAlgorithms}
                                page={"https://github.com/Laura-Gomez/larad-resistance"}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 10, md: 4, lg: 3 }}>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center'
                        }}>
                            <TarjetaDescargas
                                title={'Training'}
                                desc={'The training capsules we have created for you'}
                                image={imageData}
                                training={true}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </PageShell>
        </Box>
    )
}


const TarjetaDescargas = ({
    title,
    desc,
    image,
    page,
    training
}) => {
    const navigate = useNavigate();


    function openNewTab(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    }

    const handleTrainingVideos = () => {
        navigate("/trainingVideos");
    };


    const handleTarget = (page) => {
        if (training === true) {
            handleTrainingVideos();
        } else {
            openNewTab(page);
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxWidth: '580px',
                minHeight: '456px',
                height: '100%',

                borderRadius: 4,
                border: '1px solid #000',
                bgcolor: '#fff',
                p: '20px',

                transition: 'background-color .3s ease, border-color .3s ease',

                cursor: 'pointer',

                '&:hover': {
                    bgcolor: '#20BC71',
                    borderColor: '#20BC71',
                },

                '&:hover .hoverButton': {
                    backgroundColor: '#000',
                    color: '#fff',
                },
            }}
        >

            <Box
                sx={{
                    width: '100%',
                    aspectRatio: '16/9',
                    borderRadius: 2,
                    overflow: 'hidden',
                    mb: 3,
                    flexShrink: 0,
                }}
            >
                <Box
                    component="img"
                    src={image}
                    alt={title}
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block'
                    }}
                />
            </Box>

            <Box
                sx={{
                    width: '100%',
                    px: 1,
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >

                <Box sx={{ mb: 1 }}>
                    <Typography variant='h6'>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ flexGrow: 1, mb: '40px' }}>
                    <Typography variant='body1'>
                        {desc}
                    </Typography>
                </Box>

                <Box sx={{ mt: 'auto' }}>
                    <Button
                        variant='contained'
                        color='green'
                        className='hoverButton'
                        sx={{
                            width: '100%',
                            height: '50px',
                            borderRadius: '999px',
                            px: '30px',
                            transition: 'all .3s ease'
                        }}
                        onClick={(e) => handleTarget(page)}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant='body2'>
                                Learn more
                            </Typography>

                            <ArrowForwardIosIcon />
                        </Box>
                    </Button>
                </Box>

            </Box>
        </Box>
    )
}